import PATH from "constants/path";
import React from "react";
import { Route, Switch } from "react-router-dom";
import SubmitContact from "./pages/SubmitContact";
import ConfirmContact from "./pages/ConfirmContact";
import DoneContact from "./pages/DoneContact";
import PageNotFound from "views/PageNotFound";

function Contact() {
  return (
    <Switch>
      <Route exact path={PATH.CONTACT} component={SubmitContact} />
      <Route exact path={PATH.CONTACT_CONFIRM} component={ConfirmContact} />
      <Route exact path={PATH.CONTACT_DONE} component={DoneContact} />
      <Route component={PageNotFound} />
    </Switch>
  );
}

export default Contact;
